import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RefreshCredentialsMutationVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type RefreshCredentialsMutation = (
  { __typename: 'Mutation' }
  & Pick<SchemaTypes.Mutation, 'refreshCredentials'>
);


export const RefreshCredentialsDocument = /*#__PURE__*/ gql`
    mutation refreshCredentials {
  refreshCredentials
}
    `;
export type RefreshCredentialsMutationFn = Apollo.MutationFunction<RefreshCredentialsMutation, RefreshCredentialsMutationVariables>;

/**
 * __useRefreshCredentialsMutation__
 *
 * To run a mutation, you first call `useRefreshCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshCredentialsMutation, { data, loading, error }] = useRefreshCredentialsMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshCredentialsMutation, RefreshCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshCredentialsMutation, RefreshCredentialsMutationVariables>(RefreshCredentialsDocument, options);
      }
export type RefreshCredentialsMutationHookResult = ReturnType<typeof useRefreshCredentialsMutation>;
export type RefreshCredentialsMutationResult = Apollo.MutationResult<RefreshCredentialsMutation>;
export type RefreshCredentialsMutationOptions = Apollo.BaseMutationOptions<RefreshCredentialsMutation, RefreshCredentialsMutationVariables>;